import React, { useState, useEffect } from "react";
import TournamentDetailsHeader from "../../components/TournamentDetailsHeader";
import useGetQuery from "hooks/useGetQuery";
import RulesList from "./components/RulesList";
import { ErrorBoundary } from "react-error-boundary";
import CreateTeamButton from "pages/Games/components/CreateTeamButton";

const Rules = ({ tournamentSlug }) => {
  const rulesUrl =
"https://script.google.com/macros/s/AKfycbxVtYUb3PiRM8lKKIHd1xWuB7IJD4fr7jvL6LlK1zY7dW5kJCu2oOjz_ERLEYUKTBPvcA/exec"

  const [data, isLoading, error] = useGetQuery(
    `${rulesUrl}?id=${tournamentSlug}`
  );
  
  const [ruleData, setRuleData] = useState({});
  
  useEffect(() => {
    if (data) {
      setRuleData(data.data);
    }
  }, [data]);

  return (
    <div className=" p-2 sm:p-5 h-full overflow-y-scroll flex flex-col gap-5 ">
      <CreateTeamButton game={'overwatch'} slug={tournamentSlug}/>
      <div className="bg-[#191B2A] rounded-xl p-3 sm:p-8 flex flex-col gap-8 primary-font shadow-lg">
        <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold py-2 text-center sm:text-left">
          Rules
        </h1>
        <ErrorBoundary
          fallback={<div>Error:Tournament Details Failed to Load</div>}
        >
          <TournamentDetailsHeader tournamentSlug={tournamentSlug} />
        </ErrorBoundary>
      </div>
      <div className="bg-[#191B2A] rounded-xl p-3 sm:p-16 primary-font flex flex-col gap-4 shadow-lg">
        <ErrorBoundary fallback={<div>Error:Rules Failed to Load</div>}>
          <RulesList
            rulesLoading={isLoading}
            rulesError={error}
            rulesListData={ruleData}
          />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default Rules;
